export enum CommonOnboardingPage {
  AccountCreate = 'account_create',
  Agreements = 'agreements',
  ConsultResults = 'consult_results',
  EligibilityCheck = 'eligibility_check',
  NoShowCancellationPolicy = 'no_show_cancellation_policy',
  StripeSuccess = 'stripe_success',
  Exclusions = 'exclusions',
}

export enum CoreOnboardingPage {
  CoreLanding = 'core_landing',
}

export enum NpOnboardingPage {
  NpLanding = 'np_landing',
}

export type OnboardingPage = CommonOnboardingPage | CoreOnboardingPage | NpOnboardingPage;

export enum MemberProgram {
  CORE = 'CORE',
  NP = 'NP',
}
